<template>
  <div class="select-goods">
	  <div class="data-add">
	    <button @click="handleSelectGoods()">选择商品</button>
	  </div>
    <div class="data-preview clearfix">
      <draggable
        :list="selectedItems"
        v-bind="{ animation: 120, filter: 'input', preventOnFilter: false }"
      >	
        <div
          v-for="(item, index) in selectedItems"
          :key="index"
          class="data-item"
        >
          <i
            class="icon-close el-icon-circle-close"
            @click="handleDeleteItem(index)"
          ></i>
          <el-tooltip :content="item.name">
            <div class="item-inner">
              <div class="item-image">
                <img :src="item.banner[0].image" alt />
              </div>
            </div>
          </el-tooltip>
        </div>
      </draggable>
    </div>
    <div class="data-add" style="height: 1px;opacity: 0;">
      <button >选择商品</button>
    </div>
    <GoodsPoinModal
      ref="GoodsModal"
      :maxNum="maxNum"
      :defaultList="selectedItems"
      @handleSubmit="handleSelectGoodsSubmit"
    />
  </div>
</template>

<script>
// import PropTypes from 'ant-design-vue/es/_util/vue-types'
import draggable from "vuedraggable";
// import { pick, cloneDeep } from 'lodash'
import { GoodsPoinModal } from "@/views/apps/weishop/components/Modal";
import { resolveWeiShopApi } from "@/views/apps/weishop/region/utils/regionApiMap";

// 仅需要的字段
const itemColumns = [
  "id",
  "name",
  "banner",
  "points",
  "price",
  "stock_num",
  "sale_count"
];

// 商品选择器组件
export default {
  name: "SGoods",
  components: {
    GoodsPoinModal,
    draggable,
  },
  model: {
    prop: "value",
    event: "change",
  },
  props: {
    // 最大选择的数量限制, multiple模式下有效
    maxNum: 100,
    // 选中的商品数据
    value: [],
  },
  data() {
    return {
      // 已选择的商品列表
      selectedItems: [],
    };
  },
  watch: {
    value: {
      // 首次加载的时候执行函数
      immediate: true,
      handler(val) {
        this.onUpdate(val);
      },
    },
  },
  created() {},
  methods: {
    // 更新已选择的数据 selectedItems
    onUpdate(items) {
      this.selectedItems = items;
      this.onChange();
    },

    // 打开商品选择器
    handleSelectGoods() {
      this.$refs.GoodsModal.handle(this.selectedItems);
    },

    // 商品库modal确认回调
    handleSelectGoodsSubmit(result) {
      const { selectedItems } = result;
      const data = this.getGoodsInfoByids(selectedItems);
    },
    // 根据商品的id数组查找商品信息列表
    getGoodsInfoByids(result) {
      let _this = this;
      // 获取已有商品的ID列表（保持原有顺序）
      let oldData = [];
      if (_this.value.length > 0) {
        _this.value.map(red => {
          oldData.push(red.goods_id);
        });
      }
      // 关键修改：保持原有商品顺序在前，新选择的商品追加到后面
      // 过滤掉新选择中已存在于旧列表的商品ID（去重）
      let newIds = result.filter(id => !oldData.includes(id));
      // 旧的在前（保持拖动排序），新的在后
      let finalIds = [...oldData, ...newIds];
      finalIds = Array.from(finalIds).filter(function(element) {
        return element !== undefined && element !== null;
      });
      _this.axios
        .post(resolveWeiShopApi("/api/weishop/admin/plugin/points/goods/listByIds"), {
          form: {
            ids: finalIds,
          },
        })
        .then((res) => {
          if (res.code == 200) {
            let goods = [];
            res.data.data.map(red => {
                goods.push(red);
            });
            // 过滤仅需要的字段
            const filteredItems = goods.map((item) => {
              return _this.pick(item, itemColumns);
            });
            _this.onUpdate(filteredItems);
          } else {
            eltips(res.msg, "error");
          }
        });
    },
    // 过滤仅需要的数据
    pick(obj, keys) {
      return keys.reduce((acc, key) => {
        if (obj.hasOwnProperty(key)) {
          acc[key] = obj[key];
        }
        return acc;
      }, {});
    },
    // 过滤仅需要的数据
    filterItems(selectedItems) {
      return selectedItems.map((itm) => pick(itm, itemColumns));
    },

    // 删除商品
    handleDeleteItem(index) {
      const { selectedItems } = this;
      if (selectedItems.length <= 1) {
        this.$message.warning("请至少保留1个", 1);
        return;
      }
      selectedItems.splice(index, 1);
      this.onUpdate(selectedItems);
    },

    // 触发change事件
    onChange() {
      // let { selectedItems } = this;
	  // console.log("maxNummaxNummaxNum",this.maxNum)
	  // console.log("maxNummaxNummaxNum",selectedItems)
	  if(this.selectedItems.length>this.maxNum){
		  this.selectedItems = this.selectedItems.slice(0, this.maxNum)
	  }
      return this.$emit("change", this.selectedItems);
    },
  },
};
</script>

<style lang="less" scoped>
	.select-goods{
		overflow: hidden;
	}
// 商品信息
.data-preview {
  .data-item {
    float: left;
    margin: 5px;
    height:48px;
    width: 48px;
    background: #f7fafc;
    position: relative;
    border-radius: 3px;
    cursor: move;
    &:hover {
      .icon-close {
        display: block;
      }
    }
  }
  .icon-close {
    display: none;
    position: absolute;
    top: -8px;
    right: -8px;
    cursor: pointer;
    font-size: 16px;
    color: #c5c5c5;
    &:hover {
      color: #7d7d7d;
    }
  }
  .item-inner {
    // padding: 10px;
    // background: #f7fafc;
  }
  .item-image {
    width: auto;
    min-width: 48px;
    max-width: 48px;
    text-align: center;
	background: #f7fafc;
    img {
      display: block;
      max-width: 100%;
      height: 48px;
    }
  }
}

// 新增数据
.data-add {
  margin-top: 10px;
	&-but{
		
	}
  button {
    width: 100%;
    font-size: 14px;
	cursor: pointer;
	margin-bottom: 10px;
	height: 35px;
	line-height: 35px;
	border-radius: 5px;
	
	text-align: center;
	color: #006aff;
	background-color: #fff;
	border: 1px solid #006aff;
	display: block;
    &:hover {
      border-color: #006aff;
    }
  }
}
</style>
